import * as React from 'react';

import { connect } from 'react-redux';
import { IAppState } from '@/store/root-reducer';

import { getModulePageRows } from '@/store/layout-page/layout-page.selectors';
import { ILayoutPageData, ILayoutPageRequest, PageType } from '@/api/layout-page';
import { Dispatch } from 'redux';
import { fetchLayoutPage } from '@/store/layout-page/layout-page.actions';
import { getMobileConfig, getServerHttpStatus } from '@/store/app-config/app-config.selectors';
import { serverReturnedHttpError } from '@/utils/utils';
import { getMainCategory } from '@/services/homepage.service';
import { WithTranslation, withTranslation } from 'react-i18next';
import { PageRows } from '@/lazyImports';
import { RouteComponentProps, withRouter } from '@/utils/withRouter';

interface IModulePageProps extends RouteComponentProps<{ category: string }>, WithTranslation {
    pageRows: ILayoutPageData[];
    pageType: PageType;
    isInMobileView?: boolean;
    isInTabletView?: boolean;
    isMobileDevice: boolean;
    serverHttpStatus: number | null;
    fetchModulePage: (params: ILayoutPageRequest) => any;
}

class LayoutPage extends React.Component<IModulePageProps> {
    constructor(props: IModulePageProps) {
        super(props);

        if (!serverReturnedHttpError(props.serverHttpStatus)) {
            this._fetchPageRows();
        }
    }

    componentDidUpdate(prevProps: IModulePageProps) {
        if (prevProps.params.category !== this.props.params.category || prevProps.pageType !== this.props.pageType) {
            this._fetchPageRows();
        }
    }

    public render() {
        const { pageRows, isInMobileView, isInTabletView, isMobileDevice } = this.props;

        return (
            <PageRows
                isMobileDevice={isMobileDevice}
                pageRows={pageRows}
                isInMobileView={!!isInMobileView}
                isInTabletView={!!isInTabletView}
            />
        );
    }

    private _fetchPageRows() {
        const category = this.props.params.category;

        if (category) {
            const pageType = this.props.pageType;
            const pageCategory = getMainCategory(this.props.i18n.language, category) || '';

            this.props.fetchModulePage({
                pageType,
                pageCategory,
            });
        }
    }
}

const mapStateToProps = (state: IAppState) => ({
    pageRows: getModulePageRows(state),
    isInMobileView: getMobileConfig(state).isInMobileView,
    isInTabletView: getMobileConfig(state).isInTabletView,
    isMobileDevice: getMobileConfig(state).isMobileDevice,
    serverHttpStatus: getServerHttpStatus(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchModulePage: (params: ILayoutPageRequest) => dispatch(fetchLayoutPage.request(params)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LayoutPage)));
